// src/lib/challenges.ts

export type ChallengeType = 'math' | 'spell'

export interface Challenge {
  type: ChallengeType
  question: string
  answer: string        // canonical correct answer (lowercase, trimmed)
  hint: string          // shown on 2nd wrong attempt before accepting
}

const MATH: Challenge[] = [
  { type: 'math', question: '3 + 4 = ?',   answer: '7',  hint: 'Räkna på fingrarna!' },
  { type: 'math', question: '5 + 6 = ?',   answer: '11', hint: 'Lite mer än 10...' },
  { type: 'math', question: '8 + 3 = ?',   answer: '11', hint: 'Nästan ett dussin!' },
  { type: 'math', question: '9 + 5 = ?',   answer: '14', hint: 'Mer än 13...' },
  { type: 'math', question: '7 + 8 = ?',   answer: '15', hint: 'Halvtannat dussin!' },
  { type: 'math', question: '6 + 7 = ?',   answer: '13', hint: 'Lite mer än 12...' },
  { type: 'math', question: '4 + 9 = ?',   answer: '13', hint: 'Otur-siffran...' },
  { type: 'math', question: '10 + 7 = ?',  answer: '17', hint: 'Tio plus sju...' },
  { type: 'math', question: '12 - 4 = ?',  answer: '8',  hint: 'Tänk på ett spindelnät...' },
  { type: 'math', question: '15 - 6 = ?',  answer: '9',  hint: 'En siffra, nästan 10!' },
  { type: 'math', question: '11 - 5 = ?',  answer: '6',  hint: 'Hälften av tolv minus ett...' },
  { type: 'math', question: '14 - 7 = ?',  answer: '7',  hint: 'Samma siffra två gånger!' },
  { type: 'math', question: '10 - 3 = ?',  answer: '7',  hint: 'Sju dagar i veckan!' },
  { type: 'math', question: '13 - 5 = ?',  answer: '8',  hint: 'Spindeln har 8 ben...' },
  { type: 'math', question: '16 - 9 = ?',  answer: '7',  hint: 'Lyckosiffran!' },
  { type: 'math', question: '2 + 8 + 3 = ?', answer: '13', hint: 'Två steg: 2+8 är 10, plus 3...' },
  { type: 'math', question: '5 + 5 + 4 = ?', answer: '14', hint: 'Tio plus fyra...' },
  { type: 'math', question: '3 + 7 + 2 = ?', answer: '12', hint: 'Ett dussin ägg!' },
]

const SPELL: Challenge[] = [
  { type: 'spell', question: 'Stava KANIN',   answer: 'kanin',   hint: 'K - A - N - I - N' },
  { type: 'spell', question: 'Stava MOROT',   answer: 'morot',   hint: 'M - O - R - O - T' },
  { type: 'spell', question: 'Stava PÅSK',    answer: 'påsk',    hint: 'P - Å - S - K' },
  { type: 'spell', question: 'Stava BLOMMA',  answer: 'blomma',  hint: 'B - L - O - M - M - A' },
  { type: 'spell', question: 'Stava FJÄRIL',  answer: 'fjäril',  hint: 'F - J - Ä - R - I - L' },
  { type: 'spell', question: 'Stava KORG',    answer: 'korg',    hint: 'K - O - R - G' },
  { type: 'spell', question: 'Stava VÅRDAG',  answer: 'vårdag',  hint: 'V - Å - R - D - A - G' },
  { type: 'spell', question: 'Stava CHOKLAD', answer: 'choklad', hint: 'C - H - O - K - L - A - D' },
  { type: 'spell', question: 'Stava GÖMMA',   answer: 'gömma',   hint: 'G - Ö - M - M - A' },
  { type: 'spell', question: 'Stava STUBBE',  answer: 'stubbe',  hint: 'S - T - U - B - B - E' },
]

const ALL_CHALLENGES = [...MATH, ...SPELL]

/** Pick a pseudo-random challenge for a given egg index (deterministic per egg) */
export function getChallengeForEgg(eggIndex: number): Challenge {
  const idx = Math.abs(Math.floor(eggIndex)) % ALL_CHALLENGES.length
  return ALL_CHALLENGES[idx]
}

/** Check if answer is correct. Lenient: trim + lowercase. */
export function checkAnswer(challenge: Challenge, userInput: string): boolean {
  const clean = userInput.trim().toLowerCase()
  return clean === challenge.answer.trim().toLowerCase()
}
